enum Element {
  /**
   * Číslo jednací
   */
  REFERENCE_NUMBER = 'REFERENCE_NUMBER',

  /**
   * Agenda
   */
  AGENDA = 'AGENDA',

  /**
   * Stručný obsah
   */
  SUMMARY = 'SUMMARY',

  /**
   * Datum vytvoření
   */
  CREATED_DATE = 'CREATED_DATE',

  /**
   * Rozhodnutí
   */
  DECISION = 'DECISION',

  /**
   * Datum rozhodnutí
   */
  DECISION_DATE = 'DECISION_DATE',

  /**
   * Forma rozhodnutí
   */
  DECISION_FORM = 'DECISION_FORM',

  /**
   * Rozhodnutí docx
   */
  DECISION_DOCX = 'DECISION_DOCX',

  /**
   * Počet listů
   */
  PAGE_COUNT = 'PAGE_COUNT',

  /**
   * Poznámka
   */
  NOTE = 'NOTE',

  /**
   * Pořadí
   */
  ORDER = 'ORDER',

  /**
   * Čárový kód
   */
  BAR_CODE = 'BAR_CODE',

  /**
   * AKCE: Upravit dokument
   */
  EDIT_DOCUMENT_BUTTON = 'EDIT_DOCUMENT_BUTTON',

  /**
   * AKCE: Stornovat
   */
  CANCEL_BUTTON = 'CANCEL_BUTTON',

  /**
   * AKCE: Stornovat rozhodnutí
   */
  CANCEL_DECISION_BUTTON = 'CANCEL_DECISION_BUTTON',

  /**
   * AKCE: Znovu otevřít
   */
  REOPEN_INTERNAL_DOCUMENT_BUTTON = 'REOPEN_INTERNAL_DOCUMENT_BUTTON',
}

export default Element;
